<template>
  <div>
    <!-- 分类管理弹窗 -->
    <div v-if="dialog_visible" class="gx-dm__modal" @click.self="handleClose">
      <div class="gx-dm__box">
        <div class="gx-dm__head">
          <div class="gx-dm__head_left">
            <div class="gx-dm__head_line"></div>
            <span class="gx-dm__title">检测词分类管理</span>
          </div>
          <button class="gx-dm__close" @click="handleClose">✕</button>
        </div>
        <div class="gx-dm__body">
          <div class="gx-dm__toolbar">
            <button class="gx-dm__btn gx-dm__new_but" @click="handleAdd"><span style="font-size: 20px;">+</span> 新增分类</button>
          </div>
          <div class="gx-dm__table">
            <table>
              <thead>
                <tr>
                  <th>检测词分类名称</th>
                  <th>分类类型</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in list" :key="row.id">
                  <td class="gx-dm__name">{{ row.dictionary_name }}</td>
                  <td>
                    <span class="gx-dm__tag" :class="row.merchant_id === 0 ? 'gx-dm__tag--sys' : 'gx-dm__tag--self'">{{ row.merchant_id === 0 ? '系统' : '自配' }}</span>
                  </td>
                  <td>
                    <div class="gx-dm__ops">
                      <button class="gx-dm__op gx-dm__op--edit" @click="handleEdit(row)">编辑</button>
                      <button class="gx-dm__op gx-dm__op--del" @click="handleDelete(row)">删除</button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!list.length">
                  <td :colspan="3" class="gx-dm__empty">暂无分类</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/编辑分类弹窗 -->
    <div v-if="formVisible" class="gx-dm__modal" @click.self="formVisible = false">
      <div class="gx-dm__box gx-dm__box--sm">
        <div class="gx-dm__head">
          <div class="gx-dm__head_left">
            <div class="gx-dm__head_line"></div>
            <span class="gx-dm__title">{{ formEdit ? '编辑检测词分类' : '新增检测词分类' }}</span>
          </div>
          <button class="gx-dm__close" @click="formVisible = false">✕</button>
        </div>
        <div class="gx-dm__body">
          <div class="gx-dm__field" v-if="ismanager">
            <label class="gx-dm__label">分类类别</label>
            <div class="gx-dm__radio-row">
              <label class="gx-dm__radio" :class="{ 'gx-dm__radio--on': is_system === 1 }">
                <input type="radio" :value="1" v-model="is_system" />
                <span class="gx-dm__radio-dot"></span>
                <span>系统</span>
              </label>
              <label class="gx-dm__radio" :class="{ 'gx-dm__radio--on': is_system === 2 }">
                <input type="radio" :value="2" v-model="is_system" />
                <span class="gx-dm__radio-dot"></span>
                <span>自配</span>
              </label>
            </div>
          </div>
          <div class="gx-dm__field">
            <label class="gx-dm__label">分类名称</label>
            <input v-model="form.dictionary_name" class="gx-dm__input" maxlength="30" placeholder="请输入检测词分类名称" />
          </div>
        </div>
        <div class="gx-dm__foot">
          <button class="gx-dm__btn" @click="formVisible = false">取消</button>
          <button class="gx-dm__btn gx-dm__btn--primary" :disabled="submitLoading" @click="submitOperate">
            {{ submitLoading ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DictionaryWordsManageNew',
  props: {
    dialog_visible: { type: Boolean, default: false },
    initList: { type: Array, default: () => [] },
    dictionary_type: { type: Number, default: 1 }
  },
  data() {
    return {
      list: [],
      ismanager: false,
      formEdit: false,
      formVisible: false,
      submitLoading: false,
      form: { id: '', dictionary_name: '' },
      is_system: 2
    }
  },
  watch: {
    initList(newVal) {
      if (newVal) {
        this.list = this.ismanager ? [...this.initList] : this.initList.filter(item => item.merchant_id !== 0)
      }
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.login.userinfo
    })
  },
  created() {
    this.ismanager = this.users && this.users.mer_user_id === '1'
    this.list = this.ismanager ? [...this.initList] : this.initList.filter(item => item.merchant_id !== 0)
  },
  methods: {
    ...mapActions({
      opAddDictionaryWords: 'ucenter/opAddDictionaryWords',
      opPutDictionaryWords: 'ucenter/opPutDictionaryWords',
      opDeleteDictionaryWords: 'ucenter/opDeleteDictionaryWords'
    }),
    handleClose() {
      this.$emit('update:dialog_visible', false)
    },
    handleAdd() {
      this.form = { id: null, dictionary_name: '' }
      this.is_system = 2
      this.formEdit = false
      this.formVisible = true
    },
    handleEdit(row) {
      this.form = { ...row }
      this.is_system = row.merchant_id === 0 ? 1 : 2
      this.formEdit = true
      this.formVisible = true
    },
    handleDelete(row) {
      this.$confirm('确定要删除该分类吗？该分类下的所有关键词都会删除。', '提示', { type: 'warning' }).then(() => {
        this.opDeleteDictionaryWords({
          data: { id: row.id, dictionary_type: this.dictionary_type },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.$emit('dataChange')
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }
        })
      }).catch(() => {})
    },
    submitOperate() {
      if (!this.form.dictionary_name || !this.form.dictionary_name.trim()) {
        this.$message.warning('请输入分类名称')
        return
      }
      this.submitLoading = true
      const data = {
        dictionary_name: this.form.dictionary_name.trim(),
        dictionary_type: this.dictionary_type,
        is_system: this.is_system
      }
      const done = (res, successMessage) => {
        this.submitLoading = false
        this.formVisible = false
        if (res.code === 200) {
          this.$message.success(successMessage)
        } else {
          this.$message.error(res.message || '操作失败')
        }
        this.$emit('dataChange')
      }
      if (!this.formEdit) {
        this.opAddDictionaryWords({ data, success: (res) => done(res, '新增成功') })
      } else {
        data.id = this.form.id
        this.opPutDictionaryWords({ data, success: (res) => done(res, '修改成功') })
      }
    }
  }
}
</script>

<style scoped>
.gx-dm__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-dm__box {
  width: 100%;
  max-width: 560px;
  border-radius: 16px;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .28);
  box-shadow: 0 20px 56px rgba(15, 23, 42, .14);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 88vh;
}
.gx-dm__box--sm {
  max-width: 420px;
}
.gx-dm__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
  background: rgb(245, 240, 232);
}
.gx-dm__head_left{
  display: flex;
  align-items: center;
   gap: 8px;
}
.gx-dm__head_line{
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: rgb(200, 68, 60);
}
.gx-dm__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-dm__close {
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #909399;
  transition: all .2s;
}
.gx-dm__close:hover {
  border-color: #f56c6c;
  color: #f56c6c;
  background: #fef0f0;
}
.gx-dm__body {
  padding: 18px 20px;
  overflow-y: auto;
}
.gx-dm__foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E1E5EE;
  flex-shrink: 0;
  align-items: center;
  background: rgb(245, 240, 232);
}
.gx-dm__toolbar {
  margin-bottom: 12px;
}
.gx-dm__btn {
  height: 34px;
  padding: 0 16px;
  border-radius: 7px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .2);
  font-size: 13px;
  color: #4A4A6A;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .16s;
}
.gx-dm__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
  box-shadow: 0 0 20px rgba(212, 169, 70, .35);
}
.gx-dm__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-dm__new_but{
  display: flex;
  align-items: center;
  gap: 5px;
  height: 30px;
  padding: 0px 12px;
  border-radius: 5px;
  cursor: pointer;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  font-size: 12px;
  color: rgb(200, 68, 60);
}
.gx-dm__table {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
}
.gx-dm__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-dm__table th {
  padding: 9px 14px;
  text-align: left;
  background: rgb(245, 240, 232);
  font-size: 11px;
  font-weight: 500;
  color: #6A6A8A;
  letter-spacing: .05em;
  white-space: nowrap;
}
.gx-dm__table td {
  padding: 12px 14px;
  font-size: 13px;
  color: #1A1A2E;
  border-top: 1px solid rgba(212, 169, 70, .07);
}
.gx-dm__name {
  font-weight: 500;
}
.gx-dm__tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.gx-dm__tag--sys {
  background: rgba(63, 182, 224, .1);
  border: 1px solid rgba(63, 182, 224, .3);
  color: #3FB6E0;
}
.gx-dm__tag--self {
  background: rgba(212, 169, 70, .1);
  border: 1px solid rgba(212, 169, 70, .3);
  color: #D4A946;
}
.gx-dm__ops {
  display: flex;
  gap: 6px;
}
.gx-dm__op {
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid;
  transition: all .16s;
}
.gx-dm__op--edit {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: #1677FF;
}
.gx-dm__op--edit:hover {
  background: #1677FF;
  color: #fff;
}
.gx-dm__op--del {
  background: rgba(248, 113, 113, .07);
  border-color: rgba(248, 113, 113, .25);
  color: #F87171;
}
.gx-dm__op--del:hover {
  background: #F87171;
  color: #fff;
}
.gx-dm__empty {
  text-align: center;
  padding: 40px 0 !important;
  color: #6A6A8A;
}
.gx-dm__field {
  margin-bottom: 14px;
}
.gx-dm__label {
  display: block;
  font-size: 12px;
  color: #4A4A6A;
  margin-bottom: 6px;
}
.gx-dm__radio-row {
  display: flex;
  gap: 16px;
}
.gx-dm__radio {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #1A1A2E;
  user-select: none;
}
.gx-dm__radio input[type='radio'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-dm__radio-dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid rgb(224, 224, 236);
  background: #FFFFFF;
  position: relative;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-dm__radio-dot::after {
  content: '';
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: rgb(200, 68, 60);
  transform: scale(0);
  transition: transform .15s;
}
.gx-dm__radio--on .gx-dm__radio-dot {
  border-color: rgb(200, 68, 60);
  color: rgb(200, 68, 60);
}
.gx-dm__radio--on span {
  color: rgb(200, 68, 60);
}
.gx-dm__radio--on .gx-dm__radio-dot::after {
  transform: scale(1);
}
.gx-dm__input {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid rgba(212, 169, 70, .18);
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
}
</style>
